import { gql } from "@apollo/client";

/**
 * Query to fetch global product variants
 * This query fetches variants with globalVariant: true filter
 */
export const globalProductVariantsQuery = gql`
  query GlobalProductVariants(
    $first: Int
    $after: String
    $last: Int
    $before: String
  ) {
    productVariants(
      first: $first
      after: $after
      last: $last
      before: $before
      filter: { globalVariant: true }
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          sku
          trackInventory
          quantityLimitPerCustomer
          preorder {
            globalThreshold
            globalSoldUnits
            endDate
          }
          product {
            id
            name
            thumbnail {
              url
            }
            productType {
              id
              name
              hasVariants
              variantAttributes {
                id
                name
                slug
                inputType
                entityType
                valueRequired
                unit
                choices(first: 100) {
                  edges {
                    node {
                      id
                      name
                      slug
                      value
                      plainText
                      richText
                      boolean
                      date
                      dateTime
                      reference
                      file {
                        url
                        contentType
                      }
                    }
                  }
                }
              }
            }
          }
          channelListings {
            id
            channel {
              id
              name
              slug
              currencyCode
            }
            price {
              amount
              currency
            }
            costPrice {
              amount
              currency
            }
            preorderThreshold {
              quantity
              soldUnits
            }
          }
          attributes {
            attribute {
              id
              name
              slug
              inputType
            }
            values {
              id
              name
              slug
              value
              plainText
              richText
              boolean
              date
              dateTime
              reference
              file {
                url
                contentType
              }
            }
          }
          media {
            id
            url
            type
            oembedData
          }
          stocks {
            id
            quantity
            quantityAllocated
            warehouse {
              id
              name
            }
          }
          weight {
            unit
            value
          }
        }
      }
    }
  }
`;

/**
 * Mutation to bulk update global variants
 * This mutation does NOT require a product ID
 */
export const globalVariantBulkUpdateMutation = gql`
  mutation GlobalVariantBulkUpdate(
    $variants: [ProductVariantBulkUpdateInput!]!
    $errorPolicy: ErrorPolicyEnum
  ) {
    productVariantBulkUpdate(
      variants: $variants
      errorPolicy: $errorPolicy
    ) {
      count
      errors {
        field
        message
        code
        index
      }
      results {
        productVariant {
          id
          name
          sku
        }
        errors {
          field
          message
          code
        }
      }
    }
  }
`;
